import {Box} from "@mui/material";

export default function CardBodyLayer2(props) {
  return (
    <Box p={{xs: 2, md: 3}}>
      {props.children}
    </Box>
  )
}